import {Progress} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon} from "~/components";
import {scoreColor} from "./SiteScoreCards";
import style from "../style/SiteCrawler.module.scss";

const cn = className.bind(style);

const GRADES = [
	{min: 90, grade: 'A', label: 'Tốt', color: '#52c41a'},
	{min: 75, grade: 'B', label: 'Khá', color: '#73d13d'},
	{min: 60, grade: 'C', label: 'Trung bình', color: '#faad14'},
	{min: 40, grade: 'D', label: 'Yếu', color: '#fa8c16'},
	{min: 0, grade: 'F', label: 'Kém', color: '#f5222d'},
];

const gradeOf = (score) => GRADES.find((g) => score >= g.min) || GRADES[GRADES.length - 1];

const STATUS_SEG = [
	{key: '2xx', label: 'OK (2xx)', color: '#52c41a'},
	{key: '3xx', label: 'Chuyển hướng (3xx)', color: '#faad14'},
	{key: '4xx', label: 'Không tìm thấy (4xx)', color: '#fa8c16'},
	{key: '5xx', label: 'Lỗi server (5xx)', color: '#f5222d'},
	{key: 'other', label: 'Khác', color: '#94a3b8'},
];

/**
 * Hero tổng quan báo cáo: vòng điểm SEO trung bình + xếp hạng, các chỉ số KPI
 * (số trang, lỗi, cảnh báo, thông tin) và thanh phân bố mã trạng thái.
 */
function ReportSummary({crawl, issueCounts, statusDist}) {

	if (!crawl) return null;

	const overall = Number(crawl.avg_score || 0);
	const grade = gradeOf(overall);
	const color = scoreColor(overall);

	const kpis = [
		{label: 'Trang đã phân tích', value: crawl.pages_crawled, icon: 'fa-light fa-file-lines', color: '#4f46e5', bg: '#eef2ff'},
		{label: 'Lỗi nặng', value: issueCounts?.error || 0, icon: 'fa-light fa-circle-exclamation', color: '#ef4444', bg: '#fef2f2'},
		{label: 'Cảnh báo', value: issueCounts?.warning || 0, icon: 'fa-light fa-triangle-exclamation', color: '#f59e0b', bg: '#fff7ed'},
		{label: 'Thông tin', value: issueCounts?.info || 0, icon: 'fa-light fa-circle-info', color: '#0ea5e9', bg: '#f0f9ff'},
	];

	const dist = statusDist || {};
	const distTotal = Object.values(dist).reduce((s, v) => s + Number(v || 0), 0);

	return (
		<div className={cn('hero')}>
			<div className={cn('heroScore')}>
				<Progress
					type="dashboard"
					percent={overall}
					format={(p) => (
						<span className={cn('heroScoreValue')} style={{color}}>
							{p}<span className={cn('heroScoreMax')}>/100</span>
						</span>
					)}
					strokeColor={color}
					size={150}
					gapDegree={90}
				/>
				<div className={cn('heroGrade')} style={{background: grade.color}}>
					Hạng {grade.grade} · {grade.label}
				</div>
				<div className={cn('heroScoreCaption')}>Điểm SEO trung bình toàn site</div>
			</div>

			<div className={cn('heroRight')}>
				<div className={cn('kpis')}>
					{kpis.map((k) => (
						<div key={k.label} className={cn('kpi')} style={{background: k.bg}}>
							<span className={cn('kpiIcon')} style={{color: k.color}}>
								<FontAwesomeIcon icon={k.icon} />
							</span>
							<div>
								<div className={cn('kpiValue')}>{k.value}</div>
								<div className={cn('kpiLabel')}>{k.label}</div>
							</div>
						</div>
					))}
				</div>

				{distTotal > 0 && (
					<div className={cn('statusWrap')}>
						<div className={cn('statusBar')}>
							{STATUS_SEG.map((s) => {
								const v = Number(dist[s.key] || 0);
								if (v === 0) return null;
								return (
									<div
										key={s.key}
										className={cn('statusSeg')}
										style={{width: `${(v / distTotal) * 100}%`, background: s.color}}
										title={`${s.label}: ${v}`}
									/>
								);
							})}
						</div>
						<div className={cn('statusLegend')}>
							{STATUS_SEG.map((s) => {
								const v = Number(dist[s.key] || 0);
								if (v === 0) return null;
								return (
									<span key={s.key} className={cn('legendItem')}>
										<i style={{background: s.color}} /> {s.label} <strong>{v}</strong>
									</span>
								);
							})}
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default ReportSummary;
